import { Mapper } from 'planning-portal-library/src/lib/core/base';
import { FeatureConfiguration } from 'planning-portal-library/src/lib/core/domain/models/feature-configuration';
import { FeatureConfigurationWebEntity } from './feature-configurations.web-entity';

export class FeatureConfigurationWebRepositoryMapper extends Mapper<
  FeatureConfigurationWebEntity,
  FeatureConfiguration
> {
  mapFrom(param: FeatureConfigurationWebEntity): FeatureConfiguration {
    return {
      name: param.name,
      isEnabled: param.isEnabled,
      value: param.value,
    };
  }

  mapTo(param: FeatureConfiguration): FeatureConfigurationWebEntity {
    return {
      name: param.name,
      isEnabled: param.isEnabled,
      value: param.value,
    };
  }
}
